// 站点内容与人物关系图谱数据（虚构化角色，用于关系结构演示）

export const siteBrand = "吃瓜门图谱";

// 核心当事人 / 相关人员（虚构角色）
export const persons = [
  {
    id: "p1",
    name: "林默",
    role: "事件当事人",
    initials: "林",
    summary:
      "事件走向的起点人物，围绕其公开表态与后续回应，牵出多条关联线索，是图谱中连线最密集的核心节点。",
    tags: ["当事人", "核心节点"],
  },
  {
    id: "p2",
    name: "苏晚晴",
    role: "事件当事人",
    initials: "苏",
    summary:
      "与核心节点存在直接交集，双方说法在不同阶段交替发声，形成事件前中段最受关注的对照线。",
    tags: ["当事人", "对照线"],
  },
  {
    id: "p3",
    name: "陈煜",
    role: "相关人员",
    initials: "陈",
    summary:
      "以第三视角介入叙事，多次以转发与间接表述参与，串联起多组此前看起来无关的关联方。",
    tags: ["相关人员", "枢纽角色"],
  },
  {
    id: "p4",
    name: "周屿",
    role: "相关人员",
    initials: "周",
    summary:
      "后期发声对象，补充信息量大，是理解事件后半段链条与几方立场转换的关键拼图。",
    tags: ["相关人员", "补位者"],
  },
];

// 关联方（机构 / 群体）
export const parties = [
  {
    id: "a1",
    name: "曜星娱乐",
    kind: "经纪 / 运营方",
    desc: "核心当事人的长期合作机构，多次对外发布口径声明，被视为信息源头之一。",
  },
  {
    id: "a2",
    name: "澄光公关",
    kind: "公关顾问",
    desc: "承担口径梳理与舆情应对角色，出现于多轮回应的署名背后。",
  },
  {
    id: "a3",
    name: "溯光传媒",
    kind: "内容 / 栏目方",
    desc: "以采访与节目形式推动公开叙事，是信息被二次扩散的主要通道。",
  },
  {
    id: "a4",
    name: "素野品牌",
    kind: "合作品牌",
    desc: "因代言合作被卷入讨论，其商务动作被外界作为判断合作去留的观察窗口。",
  },
  {
    id: "a5",
    name: "远山投资",
    kind: "资本关联",
    desc: "与相关公司存在股权与业务往来，被关注者视为利益链条的潜在一端。",
  },
  {
    id: "a6",
    name: "粉丝社群",
    kind: "舆论群体",
    desc: "以应援与讨论形式参与，是信息被放大与分化的主要场域。",
  },
];

// 人物 / 关联方之间的关系连线
export const edges = [
  { source: "p1", target: "p2", type: "亲密关系", note: "事件中被反复提及的私人交集，双方口径存在时间差。" },
  { source: "p1", target: "a1", type: "合作关系", note: "长期经纪往来，事件期间由机构对外统一表态。" },
  { source: "p2", target: "a3", type: "传播关系", note: "通过栏目访谈进入公开视野，信息在此扩散。" },
  { source: "p3", target: "p1", type: "间接关联", note: "以转发与旁证方式介入，起串联作用。" },
  { source: "p3", target: "a2", type: "工作交集", note: "与公关团队存在既往项目合作背景。" },
  { source: "p4", target: "p2", type: "间接关联", note: "后期发声补充细节，立场表述相对克制。" },
  { source: "p4", target: "a5", type: "利益关联", note: "被指涉及投资层面的业务往来，线索待核。" },
  { source: "a1", target: "a2", type: "委托关系", note: "机构与公关团队在回应期存在协作分工。" },
  { source: "a1", target: "a4", type: "商务合作", note: "代言合作受事件影响，品牌侧动态受关注。" },
  { source: "a4", target: "a6", type: "舆论影响", note: "品牌与消费者群体的互动随事件起伏。" },
  { source: "a3", target: "a6", type: "信息分发", note: "栏目内容在社群中被二次创作与传播。" },
  { source: "a5", target: "a1", type: "股权往来", note: "资本方与运营机构存在持股关联。" },
];

// 关系类型图例
export const edgeTypes = [
  { type: "亲密关系", cls: "bg-rose-600", text: "text-rose-700" },
  { type: "合作关系", cls: "bg-amber-500", text: "text-amber-700" },
  { type: "传播关系", cls: "bg-emerald-600", text: "text-emerald-700" },
  { type: "间接关联", cls: "bg-stone-400", text: "text-stone-600" },
  { type: "工作交集", cls: "bg-sky-600", text: "text-sky-700" },
  { type: "利益关联", cls: "bg-orange-600", text: "text-orange-700" },
  { type: "委托关系", cls: "bg-teal-600", text: "text-teal-700" },
  { type: "商务合作", cls: "bg-yellow-600", text: "text-yellow-700" },
  { type: "舆论影响", cls: "bg-fuchsia-600", text: "text-fuchsia-700" },
  { type: "信息分发", cls: "bg-cyan-600", text: "text-cyan-700" },
  { type: "股权往来", cls: "bg-indigo-600", text: "text-indigo-700" },
];

// 时间脉络
export const timeline = [
  {
    phase: "发酵期",
    title: "事件露出",
    text: "若干片段信息开始在社群中被截取与拼接，公开讨论量快速上升，形成第一轮热度。",
    marker: "01",
  },
  {
    phase: "回应期",
    title: "第一轮回应",
    text: "核心机构与相关方先后发布口径声明，各方表述存在差异，舆论进入对比与验证阶段。",
    marker: "02",
  },
  {
    phase: "扩散期",
    title: "多方参与",
    text: "媒体与栏目介入，更多关联方被卷入，信息经二次创作向更大范围扩散。",
    marker: "03",
  },
  {
    phase: "深化期",
    title: "补充发声",
    text: "新当事人与资本关联被提及，讨论从个人事件延伸至行业与利益链条层面。",
    marker: "04",
  },
  {
    phase: "降温期",
    title: "热度回落",
    text: "公开讨论逐步回落，焦点转向对信息可信度与传播机制的复盘。",
    marker: "05",
  },
];

// 深度解析文章
export const articles = [
  {
    id: "r1",
    category: "关系拆解",
    title: "一张关系图读懂：核心人物之间到底隔了几层",
    excerpt:
      "从亲密关系、合作关系到间接关联，人物之间往往隔着一到两层「中间人」。本页以连线密度还原最关键的几组距离。",
    img: "https://readdy.ai/api/search-image?query=Overhead%20view%20of%20people%20connected%20by%20threads%20on%20a%20cream%20table%2C%20terracotta%20and%20amber%20tones%2C%20editorial%20photography%2C%20soft%20natural%20light%2C%20minimalist%20still%20life&width=800&height=520&seq=gossip-article-1&orientation=landscape",
  },
  {
    id: "r2",
    category: "传播机制",
    title: "信息为什么会越传越失真：一次完整的扩散路径",
    excerpt:
      "栏目放大、社群再创作、品牌跟进，每经过一层处理，原始口径都会发生偏差，理解失真关键在识别每个转发节点。",
    img: "https://readdy.ai/api/search-image?query=Stack%20of%20newspaper%20sheets%20and%20folded%20letters%20with%20red%20ribbon%2C%20warm%20cream%20background%2C%20editorial%20flate%20lay%2C%20soft%20shadowless%20light%2C%20minimal&width=800&height=520&seq=gossip-article-2&orientation=landscape",
  },
  {
    id: "r3",
    category: "立场对照",
    title: "同一件事，为什么各方说法各执一词",
    excerpt:
      "当事人、机构与公关的口径差异并非偶然，角色位置决定了叙事侧重。看懂立场，才能看懂事件为何反复反转。",
    img: "https://readdy.ai/api/search-image?query=Three%20folded%20paper%20figures%20in%20different%20poses%20casting%20long%20shadows%20on%20warm%20beige%20paper%2C%20editorial%20conceptual%20art%2C%20terracotta%20accents%2C%20soft%20light&width=800&height=520&seq=gossip-article-3&orientation=landscape",
  },
];

// 常见问题（需与页面展示一一对应）
export const faqs = [
  {
    q: "吃瓜门人物关系图谱是什么？",
    a: "它是把事件中被公开提及的人物与机构按关系类型整理成一张可交互网络图，用连线的疏密与类型，帮助读者快速理解谁与谁直接关联、中间又隔着哪些层级。",
  },
  {
    q: "「核心人物」和「关联方」的区别是什么？",
    a: "核心人物通常指直接参与事件的当事人及相关人员；关联方则指被卷入的机构或群体，如经纪、公关、媒体、品牌与资本。两者通过不同类型的关系连线相互连接。",
  },
  {
    q: "图谱上的关系信息都可信吗？",
    a: "本页内容是对公开流传信息的关系梳理，仅供了解讨论结构。具体陈述的真伪仍需以当事人与权威信源发布的核实信息为准，请勿据此断言。",
  },
  {
    q: "为什么同一事件会有多种说法？",
    a: "不同角色的信息位置不同，掌握与愿意披露的细节也不同；再经媒体加工与社群二次创作，口径会进一步分化，因此需要交叉比对各信源后再作判断。",
  },
  {
    q: "如何判断我看到的截图与消息是否真实？",
    a: "建议先核实消息发布账号与时间，检索是否有权威媒体交叉报道，并留意信息是否被拼接、删改。无法溯源的单向爆料宜保持存疑。",
  },
];